import React from "react";
import { SubTitle } from "@/components/pages/Community";
import { Stack, Box, Typography } from "@mui/material";
import {
  getFullName,
  getLocation,
  getCommunityProfileUrl,
  getXUser,
  getLinkedInURL
} from "@/utils/user";
import styles from "./HelpBanner.module.scss";

const HelpBanner = ({ helpBanner }) => (
  <Stack direction="column" gap={4} useFlexGap>
    <Box sx={{ paddingX: 2, xs: { textAlign: "center" } }}>
      <SubTitle
        sx={{ fontWeight: 700, fontSize: "18px", color: "#2b4d68" }}
        className={styles.orientationBox}
      >
        {helpBanner.communityManagers.title}
      </SubTitle>
      <Stack
        direction="row"
        justifyContent={{ xs: "center", md: "flex-start" }}
        gap={3}
        sx={{ marginTop: 4 }}
        flexWrap="wrap"
        useFlexGap
      >
        {helpBanner.communityManagers.list.map(({ user }) => (
          <Stack
            key={getFullName(user)}
            className={styles.userCard}
            sx={{ xs: { textAlign: "center" } }}
          >
            <div
              className={`${styles.orientationBox} ${styles.userPictureBox}`}
            >
              <img src={user.pic} alt={getFullName(user)} />
            </div>
            <Typography className={styles.orientationBox}>
              <strong>{getFullName(user)}</strong>
              <br />
              {getLocation(user)}
            </Typography>
            <Typography
              className={styles.icons}
              sx={{ xs: { textAlign: "center", paddingX: 2 } }}
            >
              {getXUser(user) && (
                <a
                  target="_blank"
                  style={{ color: "black" }}
                  href={`https://x.com/${getXUser(user)}`}
                  rel="noreferrer"
                >
                  <i className="fa-brands fa-x-twitter fa-width-auto" />
                </a>
              )}
              {getLinkedInURL(user) && (
                <a target="_blank" href={getLinkedInURL(user)} rel="noreferrer">
                  <i className="fa-brands fa-linkedin fa-width-auto" />
                </a>
              )}
              <a
                className={styles.iconOpenstack}
                target="_blank"
                href={getCommunityProfileUrl(user)}
                rel="noreferrer"
              >
                <img
                  src="https://object-storage-ca-ymq-1.vexxhost.net/swift/v1/6e4619c…/www-images-prod/foundation-staff/icon_openstack.png"
                  alt="OpenStack"
                />
              </a>
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
    <Box>
      <SubTitle
        className={styles.orientationBox}
        sx={{ fontWeight: 700, fontSize: "18px", color: "#2b4d68" }}
      >
        {helpBanner.ambassadors.title}
      </SubTitle>
      <Stack
        direction="row"
        justifyContent={{ xs: "center", md: "flex-start" }}
        gap={3}
        sx={{ marginTop: 4 }}
        flexWrap="wrap"
        useFlexGap
      >
        {helpBanner.ambassadors.list.map(({ user }) => (
          <Stack key={getFullName(user)} className={styles.userCard}>
            <div
              className={`${styles.orientationBox} ${styles.userPictureBox}`}
            >
              {getXUser(user) ? (
                <a
                  target="_blank"
                  href={`https://x.com/${getXUser(user)}`}
                  className={styles.xUserOverlay}
                  rel="noreferrer"
                >
                  <img
                    src={user.pic}
                    alt={getFullName(user)}
                    className={styles.filterBW}
                  />
                  <div>@{getXUser(user)}</div>
                </a>
              ) : (
                <img
                  src={user.pic}
                  alt={getFullName(user)}
                  className={styles.filterBW}
                />
              )}
            </div>
            <Typography sx={{ paddingY: 0 }} className={styles.orientationBox}>
              <strong>{getFullName(user)}</strong>
              <br />
              {getLocation(user)}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  </Stack>
);

export default HelpBanner;
